import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import {Box, Button, Chip, FormControl, InputLabel, MenuItem, Select, TextField, Typography} from "@mui/material";
import Dialog from "@mui/material/Dialog";
import React, {useState} from "react";
import {useNavigate} from "react-router-dom";
import {Controller, useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {config} from "../../../constant";

export default function DialogEditNomination({open, onClose, nomination, categoryId, users, categories}) {
    const [multipleSelectOpen, setMultipleSelectOpen] = useState(false);
    const [submitted, setSubmitted] = useState(false);
    const navigate = useNavigate();

    const validationSchema = Yup.object().shape({
        categoryId: Yup.number().transform(value => (Number.isNaN(value) ? undefined : value)).required(),
        nomineesIds: Yup.array().min(1, 'Nommé est obligatoire'),
        reason: Yup.string().required("Raison est obligatoire")
    });

    const {register, reset, control, handleSubmit, formState: {errors}} = useForm({
        resolver: yupResolver(validationSchema),
        defaultValues: nomination ? {
            categoryId: nomination.category.id,
            nomineesIds: nomination.nominees.map(nominee => nominee.id),
            reason: nomination.reason
        } : {
            categoryId: categoryId,
            nomineesIds: [],
            reason: ''
        }
    });

    const getNominee = (id) => users.find(nominee => nominee.id === id);
    const getCategory = (id) => categories.find(category => category.id === id);

    // const getStyles = (user, users, theme) => {
    //     return {
    //         fontWeight:
    //             users.find(current => current.id === user.id) === undefined
    //                 ? theme.typography.fontWeightRegular
    //                 : theme.typography.fontWeightMedium,
    //     };
    // };

    // const ITEM_HEIGHT = 48;
    // const ITEM_PADDING_TOP = 8;
    // const MenuProps = {
    //     PaperProps: {
    //         style: {
    //             maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
    //             width: 250,
    //         },
    //     },
    // };

    const onSubmit = (data) => {
        const updatedNomination = {
            id: nomination ? nomination.id : null,
            category: getCategory(data.categoryId),
            reason: data.reason,
            nominees: data.nomineesIds.map(nomineeId => getNominee(nomineeId))
        };
        const requestOptions = {
            method: nomination === null ? 'POST' : 'PUT',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify(updatedNomination)
        };
        setSubmitted(true);
        fetch(`${config.BASE_URL}/nominations`, requestOptions)
            .then(response => {
                onClose(true);
                setSubmitted(false);
                if (!response.ok) {
                    throw new Error(`${response.status} ${response.statusText}`)
                }
            })
            .catch((error) => {
                const message = 'Erreur dans la création ou mise à jour d\'une nomination';
                console.error(message, error);
                navigate("/error", {state: {message: message}});
            });
    };

    return (
        <Dialog open={open} onClose={() => onClose(false)} maxWidth={'md'} fullWidth>
            <DialogTitle>Nomination</DialogTitle>
            <DialogContent>
                <form id="nominationForm" onSubmit={handleSubmit(onSubmit)}>
                    <FormControl sx={{mt: 1}} fullWidth>
                        <InputLabel id="category-label" error={!!errors.categoryId}>Catégorie</InputLabel>
                        <Controller
                            name="categoryId"
                            id="categoryId"
                            // defaultValue={[]}
                            control={control}
                            render={({field}) => (
                                <Select
                                    labelId="category-label" {...field}
                                    error={!!errors.categoryId}
                                    label="Catégorie"
                                    // MenuProps={MenuProps}
                                >
                                    {categories.map(category => (
                                        <MenuItem key={category.id} value={category.id}>
                                            {category.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            )}
                        />
                    </FormControl>
                    <Typography variant="inherit" color="textSecondary">{errors.categoryId?.message}</Typography>

                    <FormControl sx={{mt: 1}} fullWidth>
                        <InputLabel id="users-label" error={!!errors.nomineesIds}>Compétiteurs</InputLabel>
                        <Controller
                            name="nomineesIds"
                            id="nomineesIds"
                            control={control}
                            render={({field}) => (
                                <Select
                                    labelId="users-label" {...field}
                                    multiple
                                    open={multipleSelectOpen}
                                    onClose={() => setMultipleSelectOpen(false)}
                                    onOpen={() => setMultipleSelectOpen(true)}
                                    onChange={e => {
                                        setMultipleSelectOpen(false);
                                        field.onChange(e);
                                    }}
                                    label="Compétiteurs"
                                    // input={<OutlinedInput id="select-multiple-chip" label="Compétiteurs" />}
                                    renderValue={selected => (
                                        <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 0.5}}>
                                            {selected.map(nomineeId => (
                                                <Chip key={nomineeId} label={getNominee(nomineeId).firstName} />
                                            ))}
                                        </Box>
                                    )}
                                    error={!!errors.nomineesIds}
                                    // MenuProps={MenuProps}
                                >
                                    {users.map(user => (
                                        <MenuItem key={user.id} value={user.id}>
                                            {user.firstName}
                                        </MenuItem>
                                    ))}
                                </Select>
                            )}
                        />
                    </FormControl>
                    <Typography variant="inherit" color="textSecondary">{errors.nomineesIds?.message}</Typography>

                    <TextField
                        margin="dense"
                        id="reason"
                        name="reason"
                        label="Raison"
                        fullWidth
                        variant="standard"
                        multiline
                        maxRows={Infinity}
                        {...register("reason")}
                        error={!!errors.reason}
                    />
                    <Typography variant="inherit" color="textSecondary">{errors.reason?.message}</Typography>
         </form>
            </DialogContent>
            <DialogActions>
                <Button type="submit" form="nominationForm" disabled={submitted}>OK</Button>
                <Button onClick={() => onClose(false)}>Annuler</Button>
            </DialogActions>
        </Dialog>
    );
}
